<template>
  <div class="o-focus o-tabs__tab--fixed-head">
    <div class="o-panel__header" v-my-fixed-title>
      <h3 class="o-panel__title">Delivering support for communities and environment</h3>
    </div>

    <my-slider>
      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body">
          <div class="o-focus__intro">
            <p>It is part of our vision for UK Power Networks to be a respected corporate citizen. That means we work closely with communities and their representatives to identify areas where we play an active, beneficial role. Our area of operation covers the whole of London as well as large areas of rural and agricultural land and over 500 miles of coastline around the south east of England. We engage with groups as diverse as parish councils and Community Energy Groups to the London Sustainability Exchange tackling fuel poverty in London. We also play a role in helping safeguard the environment in which we operate, both by reducing our Business Carbon Footprint (BCF) and by taking action to protect and enhance the natural environment.</p>
          </div>

          <div class="o-link__btn-group">
            <my-download-button :section="'focus-communities-environment'"></my-download-button>
          </div>
        </div>
      </my-slide>

      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body o-panel__body--full">
          <div class="o-chart o-chart--focus">

            <div class="o-grid o-grid--2 o-media--2b">
              <div class="o-grid__item">
                <h4 class="o-chart__title">Business carbon footprint (tCO<sub>2</sub>e) <span>– Figures exclude losses</span></h4>
              </div>
              <div class="o-grid__item">
                <div class="o-kpi__figure">68,638</div>
              </div>
            </div>

            <my-chart :color="['orange']" :file="'focus-5'" :start-height="280" :back="24" :offset="2" :skew="50" :margin="{
              top: 20,
              right: 15,
              bottom: 20,
              left: 20
            }"></my-chart>
            <div class="u-footnote">
              <p>* Business Carbon Footprint recalculated using previous year’s carbon factors at Ofgem’s request.<br>
              Business Carbon Footprint was calculated by calendar year until 2013 and changed to regulatory year from 2014/15 onwards as per Ofgem’s request.</p>
            </div>
          </div>
        </div>
      </my-slide>

      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body o-panel__body--full o-panel__body--squish">
          <div class="o-grid o-grid--2">

            <div class="o-grid__item o-grid__item--max">
              <div class="o-kpi--circle o-kpi--circle--top o-kpi--circle--red">
                <div class="o-kpi--circle__inner">
                  <h4 class="o-kpi__figure">1.05million</h4>
                  <p class="o-kpi__caption">customers registered on The Priority Services Register, compared to 0.7m in 2015/16</p>
                </div>
              </div>
            </div>

            <div class="o-grid__item o-grid__item--max">
              <div class="o-kpi--circle o-kpi--circle--top o-kpi--circle--red">
                <div class="o-kpi--circle__inner">
                  <h4 class="o-kpi__figure">16%</h4>
                  <p class="o-kpi__caption">reduction in the Business Carbon Footprint of the vehicle fleet working on our network in the last two years</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </my-slide>

    </my-slider>

  </div>
</template>

<script>
import MyChart from '@/components/standard/my-chart'
import MyDownloadButton from '@/components/standard/my-download-button'
import { MySlider, MySlide } from '@/components/standard/my-slider'
import { MyFixedTitle } from '@/directives/my-fixed-title.js'

export default {
  name: 'my-focus-community',
  components: {
    MyChart,
    MyDownloadButton,
    MySlider,
    MySlide
  },
  directives: {
    MyFixedTitle
  }
}
</script>



// WEBPACK FOOTER //
// MyFocusCommunity.vue?06558520